export default {
	FEATURE: 'feature',
	CONTEXT: 'context'
};